module.exports = __webpack_public_path__ + "img/the-starter-hover.616fda47.png";